module.exports = __webpack_public_path__ + "static/media/intro3.6309da1b.mp4";